import request from '@/utils/request'

/**
 * 获取首页统计数据
 * @param schoolId 学校ID（可选）
 * @param storeId 仓库/门店ID（可选）
 * @param productCategoryId 商品分类ID（可选）
 */
export function getHomeStatistics(params = {}) {
  return request({
    url: 'api/home/statistics/info',
    method: 'get',
    params
  })
}

/**
 * 获取订单统计数据
 * @param startDate 开始日期，格式：yyyy-MM-dd
 * @param endDate 结束日期，格式：yyyy-MM-dd
 */
export function getOrderStatistics(startDate, endDate) {
  return request({
    url: 'api/home/statistics/orderStatistics',
    method: 'get',
    params: { startDate, endDate }
  })
}

/**
 * 刷新统计数据缓存
 */
export function refreshStatisticsCache() {
  return request({
    url: 'api/home/statistics/refreshCache',
    method: 'get'
  })
}

/**
 * 获取营业数据统计
 * @param startDate 开始日期，格式：yyyy-MM-dd
 * @param endDate 结束日期，格式：yyyy-MM-dd
 * @param schoolId 学校ID（可选）
 * @param storeId 门店ID（可选）
 */
export function getBusinessStatistics(startDate, endDate, schoolId, storeId) {
  return request({
    url: 'api/home/statistics/business',
    method: 'get',
    params: { startDate, endDate, schoolId, storeId }
  })
}

/**
 * 获取会员数据统计
 * @param startDate 开始日期，格式：yyyy-MM-dd
 * @param endDate 结束日期，格式：yyyy-MM-dd
 * @param schoolId 学校ID（可选）
 * @param storeId 门店ID（可选）
 * @param topLimit 排行榜数量限制（默认10）
 */
export function getMemberStatistics(startDate, endDate, schoolId, storeId, topLimit = 10) {
  return request({
    url: 'api/home/statistics/member',
    method: 'get',
    params: { startDate, endDate, schoolId, storeId, topLimit }
  })
}

/**
 * 获取商品销售数据统计
 * @param startDate 开始日期，格式：yyyy-MM-dd
 * @param endDate 结束日期，格式：yyyy-MM-dd
 * @param schoolId 学校ID（可选）
 * @param storeId 门店ID（可选）
 * @param topLimit 排行榜数量限制（默认10）
 * @param rankBy 排序方式（amount/quantity/profit，默认amount）
 * @param sourceType 销售渠道（可选）：0-PC订单，1-小程序，2-自助终端
 */
export function getProductStatistics(startDate, endDate, schoolId, storeId, topLimit = 10, rankBy = 'amount', sourceType = null) {
  return request({
    url: 'api/home/statistics/product',
    method: 'get',
    params: { startDate, endDate, schoolId, storeId, topLimit, rankBy, sourceType }
  })
}

/**
 * 获取商品销售排行榜（分页）
 * @param params 查询参数
 */
export function getProductRankingPage(params) {
  return request({
    url: 'api/home/statistics/product/ranking',
    method: 'get',
    params
  })
} 

/**
 * 获取单个商品的销售分析数据
 * @param productId 商品ID
 * @param startDate 开始日期，格式：yyyy-MM-dd
 * @param endDate 结束日期，格式：yyyy-MM-dd
 * @param schoolId 学校ID（可选）
 * @param storeId 门店ID（可选）
 * @param sourceType 销售渠道（可选）：0-PC订单，1-小程序，2-自助终端
 * @param pageNum 页码（可选，默认1）
 * @param pageSize 每页数量（可选，默认20）
 */
export function getProductSalesAnalysis(productId, startDate, endDate, schoolId, storeId, sourceType = null, pageNum = 1, pageSize = 20) {
  return request({
    url: `api/home/statistics/product/${productId}/analysis`,
    method: 'get',
    params: { startDate, endDate, schoolId, storeId, sourceType, pageNum, pageSize }
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js